import { Field } from 'components/Field'
import { FormFieldProps } from 'components/FormFields'
import React, { HTMLAttributes } from 'react'
import styled, { css } from 'styled-components'

export const dateFieldStyles = css`
	input[type='date'] {
		align-items: flex-start;
	}
	input::-webkit-date-and-time-value {
		margin-top: 0px;
		text-align: left;
		width: 100%;
		min-height: 21px;
	}
`

const DateFieldView = styled.div`
	${dateFieldStyles}
`

export type DateFieldProps = FormFieldProps &
	Pick<HTMLAttributes<HTMLInputElement>, 'onChange' | 'title' | 'className'> & {}

export const DateField = ({ onChange, title, className, name, ...fieldProps }: DateFieldProps) => {
	const props = {
		onChange,
		title,
		name,
		type: 'date',
	}
	return (
		<DateFieldView className={`date-field${className ? ` ${className}` : ''}`}>
			<Field {...fieldProps} name={name}>
				<input {...props} />
			</Field>
		</DateFieldView>
	)
}
